export default (date, isCurrent) => {
  setTimeout(() => {
    const list = document.getElementsByClassName(
      'react-datepicker__year-container-text',
    );
    if (list) {
      if (list.length > 0) {
        [...list].forEach((element, i) => {
          if (
            !isCurrent &&
            date &&
            element.innerHTML === `${date.getFullYear()}`
          ) {
            [...list][i].classList.add('selected');
          } else {
            [...list][i].classList.remove('selected');
          }
        });
      }
    }
  });
};
